import React from "react";
import styles from "../addCategoryForm/addCategoryForm.module.css";
import { Add } from "@mui/icons-material";
import { Delete } from "../../Svg";

const ViewPricingCard = ({ handleChange, handleBlur, values, touched, errors }) => {

   
    return (
        <div>
            <div className={styles.card}>
                <h2 className={styles.addCatH2}>Pricing</h2>

                {/* Pricing Table */}
                {values.quantityTable?.map((item, index) => (
                    <>
                        {values?.quantityTable?.length > 1 &&
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 25, alignItems: 'center' }}>
                                <div>
                                    Price {index + 1}
                                </div>

                            </div>
                        }
                        <label className={styles.addCatLabel} >
                            Unit Price
                            <input

                                className={styles.addCatInput}
                                value={item.unitPrice}

                            />
                        </label>
                        <div key={index} style={{ display: "flex", gap: "14px", marginTop: "10px", flex: 1 }}>
                            {/* Packaging Dropdown */}
                            <label className={styles.addCatLabel} style={{ flex: 1 }}>
                                Packaging
                                <select

                                    className={styles.addCatSelect}
                                    value={item.packaging}
                                    disabled
                                >
                                    <option value="">Select</option>
                                    <option value="Spool">Spool</option>
                                    <option value="Tape & Reel">Tape & Reel</option>
                                    <option value="Bulk">Bulk</option>
                                </select>
                            </label>

                            {/* Break Quantity Input */}
                            <label className={styles.addCatLabel} style={{ flex: 1 }}>
                                Break Quantity
                                <input
                                
                                    className={styles.addCatInput}
                                    value={item.breakQty}
                                 
                                />
                            </label>

                            {/* Unit Price Input */}


                            {/* Sale Price Input */}
                            <label className={styles.addCatLabel} style={{ flex: 1 }}>
                                min Multiplier
                                <input
                                   
                                    className={styles.addCatInput}
                                    value={item.minMultiplier}
                                   
                                />
                            </label>
                        </div>

                    </>
                ))}

               
            </div>
        </div>
    );
};

export default ViewPricingCard;
